import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, Row, Col, Button, Typography, Form } from "antd";
import { useDispatch } from "react-redux";
import { SelectItem as SelectItemComponent } from "../../../components/forms/FormItems";
import { commitChanges, loadProspectus } from "../prospectusSlice";
import { useSelector } from "react-redux";
import FormActions from "../../../components/forms/FormActions";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { CloseOutlined } from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
const { Title } = Typography;

const MissingHoursModal = (props) => {
  const { hide, visible, prospectusLine } = props;
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const loading = useSelector(
    (state) => state.pendingActions["prospectus/update"]
  );

  useEffect(() => {
    if (prospectusLine && visible) {
      form.setFieldsValue({
        missing_hours_reason:
          prospectusLine["missing_hours_reason"] === 0
            ? null
            : prospectusLine["missing_hours_reason"],
      });
    }
  }, [prospectusLine, visible]);

  const onFinish = async (values) => {
    const line = {
      lineId: prospectusLine.id,
      prospectusId: prospectusLine.prospectus_id,
      prospectusLine: { ...values },
    };

    const action = await dispatch(commitChanges(line));
    if (!action.error) {
      dispatch(loadProspectus());
      hide();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };
  const layout = {
    labelCol: { span: 6, offset: 2 },
    wrapperCol: { span: 11, offset: 1 },
  };

  return (
    <Modal
      closable={false}
      maskClosable={false}
      open={visible}
      footer={null}
      onCancel={hide}
      title={null}
      width={"fit-content"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      destroyOnClose={true}
    >
      <div>
        <div className="header" style={{ height: "40px" }}>
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onDecline}
          />
        </div>
        <Title
          style={{
            fontSize: "30px",
            fontWeight: 500,
            lineHeight: 1.27,
            color: "rgba(0, 0, 0, 0.85)",
            margin: "13px 0 40px 0 ",
            textAlign: "center",
          }}
        >
          <FormattedMessage
            id={`app.forms.prospectuses.title.missingHoursReason`}
          />
        </Title>
        <Form
          {...layout}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
          style={{
            padding: "0 128px 0px 128px",
            width: "850px",
          }}
        >
          <ChildrenAnimationWrapper>
            <Row>
              <Col span={24} style={{ padding: "0 20px" }}>
                <AnimationChildWrapper key={1} itemKey={1}>
                  <SelectItemComponent
                    name="missing_hours_reason"
                    category="prospectuses"
                    missingHoursReason={true}
                  />
                </AnimationChildWrapper>
              </Col>
              <Row style={{ width: "100%" }}>
                <Col span={24}>
                  <FormActions
                    resource="accounting"
                    action="editor"
                    onCancel={onDecline}
                    hideDelete={true}
                    hideDecline={true}
                    saveLoading={loading}
                    // disabled={!activeProspectus}
                  />
                </Col>
              </Row>
            </Row>
          </ChildrenAnimationWrapper>
        </Form>
      </div>
    </Modal>
  );
};
MissingHoursModal.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default MissingHoursModal;
